/**
 * Substitutes quick reply template variables based on agent profile.
 *
 * Variables:
 *   #AgentName → agent nickname
 *   #ค่ะ       → ค่ะ (female) / ครับ (male)
 *   #คะ        → คะ (female) / ครับ (male)
 *
 * @param {string} content - Template content with variable placeholders
 * @param {object} profile - Agent profile { nickName, sex }
 * @returns {string} Content with variables replaced
 */
export function substituteQuickReplyVars(content, profile) {
  if (!content || !profile) return content || '';

  const isMale = profile.sex === 'M';

  return content
    .replace(/#AgentName/g, profile.nickName || '')
    .replace(/#ค่ะ/g, isMale ? 'ครับ' : 'ค่ะ')
    .replace(/#คะ/g, isMale ? 'ครับ' : 'คะ');
}



// WEBPACK FOOTER //
// ./src/functions/quick-reply-vars.js